module.exports = __webpack_public_path__ + "static/media/coming-soon-bg.6de432d0.jpg";